<template>
  <div class="note-container">
    <div
      class="note"
      :style="{
        '--line-height': lineHeight + 'px',
        '--font-size': fontSize + 'px',
        // 'width': width + 'px',
        'min-height': minHeight + 'px'
      }"
    >
      <div class="lines">
        <div
          class="content"
          :contenteditable="editable"
          @input="handleInput"
          :style="{ paddingTop: paddingTop + 'px' }"
        >
            <p>
                <slot>
                    <span>轻敲此处开始书写</span>
                </slot>
            </p>
            <p style="text-align: end" v-if="title">——《{{ title }}》</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinedNote',
  props: {
    lineHeight: {
      type: Number,
      default: 28
    },
    fontSize: {
      type: Number,
      default: 16
    },
    // width: {
    //   type: Number,
    //   default: 280
    // },
    minHeight: {
      type: Number,
      default: 120
    },
    editable: {
      type: Boolean,
      default: true
    },
    paddingTop: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.innerHTML);
    }
  }
}
</script>

<style scoped>
.note-container {
  font-family: 'LXGW WenKai', cursive;
}

.note {
  background: #fefff3;
  padding: 35px 25px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(143, 187, 206, 0.15);
  position: relative;
}

.lines {
  background-image: repeating-linear-gradient(
    to bottom,
    transparent 0px,
    transparent calc(var(--line-height) - 1px),
    #d3e9f4 calc(var(--line-height) - 1px),
    #d3e9f4 var(--line-height)
  );
  height: 100%;
}

.content {
  font-size: var(--font-size);
  line-height: var(--line-height);
  color: #5a7c8a;
  position: relative;
  top: -1px;
  text-align: start;
}

.content p {
  text-indent: 2em;
  margin: 0;

}

[contenteditable] {
  margin: 0;
  padding: 0;
}

[contenteditable]:focus {
  outline: none;
}

@media print {
  .note-container {
    background: none;
  }
  .note {
    box-shadow: none;
  }
}
</style>
